module.exports = __webpack_public_path__ + "img/na.bc959ed2.svg";